import { type Ref } from 'vue'


import { type Product } from '@/types'

export const useProductMeta = (product: Ref<Product | undefined>) => {
  const title = computed(() => {
    return product.value ? '%s | Kind & Conscious'.replace('%s', product.value.title) : 'Kind & Conscious'
  })

  const description = computed(() => {
    return product.value ? product.value.description : ''
  })

  useHead({
    title,
    meta: [
      { 
        name: 'description', 
        content: description 
      },
      {
        hid: 'og:title',
        name: 'og:title',
        content: title
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content: description
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: description
      },
    ]
  })

  // [TBI] Add in og:image and twitter:image from product image:
  
  return {
    title,
    description
  }
}